import Vue from 'vue'
import VueRouter from 'vue-router'
//import Home from './views/Home.vue'
//import Login from './views/Login.vue';

Vue.use(VueRouter)


const router = new VueRouter({
  routes: [
    /*{
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }*/
    //{
    //  path: '/about',
    //  name: 'about',
    //  // route level code-splitting
    //  // this generates a separate chunk (about.[hash].js) for this route
    //  // which is lazy-loaded when the route is visited.
    //  component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    //}
  ],
  mode: 'history'
})
/*
router.beforeEach((to, from, next) => {
    //console.log(to);
    next();
});*/

export default router;